import { Container } from "@mui/material";
import React from "react";
import "./PrivacyPolicy.css";
const PrivacyPolicy = () => {
  return (
    <div>
      <Container maxWidth="md" className="privacy">
        <h1 className="pri">Privacy Policy</h1>
        <h4 className="poi">Privacy Policy</h4>
        <p className="para">
          The website aganadhigaram.com ("Website") is owned and operated by
          Agan Adhigaram Publishing house®. We are aware that
          users/visitors/customers who access our website are concerned about
          how their personal information is used or shared. This Privacy Policy
          ("Policy") conveys the manner in which such information is used by us
          while providing the services of the Website. Please read this Policy
          in conjunction with our Terms and Conditions. By using or accessing
          any part of this Website, you are deemed to have accepted the terms of
          this Policy. Agan Adhigaram Publishing house® may revise the Policy at
          any time without notice to anyone.
        </p>
        <h4 className="poi">Sign-up</h4>
        <p className="para">
          In order to shop on the Website, you could sign in as a Guest user. Or
          you could create an account by completing the registration process,
          for which you need to provide your contact information and verify a
          valid email address. If you have signed up as a member and agreed to
          receive certain emails, you may get emails containing information
          regarding products, community activity, and directives from Agan
          Adhigaram Publishing house® from time to time. Under rare
          circumstances, we may need to contact specific or all members in order
          to make an important announcement about the Website or service
          changes. Members will not able to unsubscribe from these announcements
          because they may contain very important information regarding their
          accounts. Members may, however, unsubscribe from receiving our
          electronic newsletters at any time by following the instructions
          contained at the end of every newsletter.
        </p>
        <h4 className="poi">Information collected</h4>
        <p className="para">
          The Website collects personally identifiable information about you
          only during the Sign-up process: your name, email address, mailing
          address, birth date, gender, occupation, industry, personal interests,
          and so on. Except as set forth in this Policy, you will be notified
          when personal information may be shared with third parties, and will
          be able to prevent the sharing of this information.
        </p>
        <h4 className="poi">Use of information collected</h4>
        <p className="para">
          The Website uses information for two general purposes: 1) to provide
          better service to users and ensure on-time deliveries of orders and 2)
          to contact users about special offers and promotions. This policy may
          however be amended from time to time. Agan Adhigaram Publishing house®
          takes your privacy very seriously. Agan Adhigaram Publishing house®
          does not share, sell or rent your contact information. We may use any
          user information given voluntarily to enhance user experience on the
          Website, and to better prepare future content based on user interests.
          There are times when it may be necessary for us to make certain
          personal information about users available to logistical partners who
          may help us process information, fulfil customer orders and deliver
          products to users, or who may manage and enhance customer data,
          provide customer service, or conduct customer research or satisfaction
          surveys. We may also at times be required to disclose such personal
          information under law or litigation, for national security or law
          enforcement, or for other issues of public importance.
        </p>
        <h4 className="poi">Protection of Information</h4>
        <p className="para">
          We use a secure server that encrypts all information you put in when
          sending it to us. This server is kept in a protected environment and
          is professionally maintained. While we use both passwords and user
          names to protect information online, we also take steps to protect
          your information offline. All personally identifiable information is
          restricted in our office, and used only as mentioned in this privacy
          policy. We also encourage you as users to take precautions to protect
          your personal data when on the internet. Among other things, you are
          advised to change your password often, using a combination of letters
          and numbers, and make sure you use a secure web browser. Please keep
          in mind that you are solely responsible for maintaining the secrecy of
          your passwords and/or any account information.{" "}
        </p>
        <h4 className="poi">Hyperlinks</h4>
        <p className="para">
          The Website provides links to other websites (“Sites”), which are not
          in our control. Users acknowledge that Agan Adhigaram Publishing
          house® does not endorse these Sites (even if they pop up in a frame)
          or any links contained in them. In addition, we are not responsible
          for any content or the privacy policies of these Sites, or for any
          data collected on you by them.
        </p>

        <h4 className="poi">Governing Law</h4>
        <p className="para">
          This Agreement has been executed and delivered in India, and its
          interpretations, validity and performance shall be construed and
          enforced in accordance with the laws of India, and shall be subject to
          the jurisdiction of the High Court in Chennai.
        </p>

        <h4 className="poi">Disclaimer</h4>
        <p className="para">
          Users’ access to the Website is at their own risk. This Website is
          provided by Agan Adhigaram Publishing house® on an "as is" and "as
          available" basis. To the full extent permissible by applicable law,
          cyber site disclaims all warranties, express or implied, including,
          but not limited to, implied warranties of merchantability, fitness for
          a particular purpose and non-infringement.
        </p>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
